import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { ADMIN } from "../../constants/testIds";

const COLORS = { spotify: "#1DB954", ytmusic: "#FF0000", unknown: "#818CF8" };

export const OutboundClicksWidget = ({ data, loading }) => {
  const rows = data?.outbound_breakdown || [];
  const total = rows.reduce((s, r) => s + r.count, 0);

  return (
    <div className="p-5 sm:p-6 rounded-xl border border-slate-800 bg-slate-900/80 backdrop-blur-md">
      <h3 className="text-lg font-semibold text-slate-200 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Outbound Clicks — Spotify vs YouTube</h3>
      {loading ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : total === 0 ? (
        <p className="text-sm text-slate-500">No outbound clicks recorded yet.</p>
      ) : (
        <div data-testid={ADMIN.outboundChart} style={{ width: "100%", height: 240 }}>
          <ResponsiveContainer minWidth={200} minHeight={150}>
            <PieChart>
              <Pie data={rows} dataKey="count" nameKey="platform" innerRadius={55} outerRadius={85} paddingAngle={3}>
                {rows.map((r) => (
                  <Cell key={r.platform} fill={COLORS[r.platform] || "#F59E0B"} />
                ))}
              </Pie>
              <Tooltip contentStyle={{ background: "#0F172A", border: "1px solid #334155" }} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
